import { createSlice } from "@reduxjs/toolkit";
import {
  getAdditionalIncomeSummary,
  getAdditionalIncomeActivities,
} from "../../reducer/additionalIncome/additionalIncomeReducer";

const initialState = {
  summary: {
    data: null,
    loading: false,
    error: null,
  },
  activities: {
    data: null,
    loading: false,
    error: null,
  },
};

const additionalIncomeSlice = createSlice({
  name: "additionalIncome",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Summary
    builder
      .addCase(getAdditionalIncomeSummary.pending, (state) => {
        state.summary.loading = true;
        state.summary.error = null;
      })
      .addCase(getAdditionalIncomeSummary.fulfilled, (state, action) => {
        state.summary.loading = false;
        state.summary.data = action.payload?.data || action.payload;
      })
      .addCase(getAdditionalIncomeSummary.rejected, (state, action) => {
        state.summary.loading = false;
        state.summary.error = action.payload;
      });

    // Activities
    builder
      .addCase(getAdditionalIncomeActivities.pending, (state) => {
        state.activities.loading = true;
        state.activities.error = null;
      })
      .addCase(getAdditionalIncomeActivities.fulfilled, (state, action) => {
        state.activities.loading = false;
        state.activities.data = action.payload?.data || action.payload;
      })
      .addCase(getAdditionalIncomeActivities.rejected, (state, action) => {
        state.activities.loading = false;
        state.activities.error = action.payload;
      });
  },
});

export default additionalIncomeSlice.reducer;
